import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ScreenManagerService} from '@mpt-fo/common/core/services/screen-manager.service';
import {BusinessService, OTPCreationRoute} from '@mpt-fo/common/core/services/business.service';

@Component({
	selector: 'app-pin',
	templateUrl: './pin.component.html',
	styleUrls: ['./pin.component.scss']
})
export class PinComponent implements OnInit {
	isMobile: any = false;
	readonly TOTAL_STEP = 2;
	currentStep: any;
	readonly INITIAL_STEP = 0;
	formSteps = [
		{
			step: 1,
			key: 'PIN_CREATION',
			title: 'Transaction Pin',
			description: 'Please enter information below',
			url: 'pin/business-pin',
			previousUrl: 'selection-mode',
			previousTitle: 'Selection Mode'
		},
		{
			step: 2,
			key: 'OTP',
			title: 'OTP',
			description: 'We’ve just sent you a 6 digit code. ' +
				'Check your messages and enter it here.',
			url: 'pin/otp',
			previousUrl: 'pin/business-pin',
			previousTitle: 'Transaction Pin'
		}
	];

	constructor(private screenManagerService: ScreenManagerService, private router: Router, private businessService: BusinessService) {
	}


	ngOnInit(): void {
		this.isMobile = this.screenManagerService.isMobile();
		this.screenManagerService.isMobile$.subscribe(isMobile => {
			this.isMobile = isMobile;
		});
		this.initialize();
		this.businessService.otpCreationNavigationObserver$
			.subscribe((e: OTPCreationRoute) => {
				this.initialize(e);
			});
	}

	initialize(currentRoute = null) {
		if (!currentRoute) {
			currentRoute = this.formSteps[this.INITIAL_STEP];
		}
		const currentStep = this.formSteps.find(x => x.key === currentRoute?.key);
		this.currentStep = currentStep;
		const otpFormData = this.businessService.getData();
		otpFormData.currentRoute = this.currentStep;
		this.businessService.saveData(otpFormData);
	}

	goBack() {
		const routes = this.businessService.getKycRoutes();
		const route = routes.find(x => x.route === this.currentStep.previousUrl);
		if (route) {
			route.completed = false;
			this.businessService.navigateKYCForm(route);
		} else {
			this.businessService.resetRoute();
			this.router.navigateByUrl('user/selection-mode');
		}
	}

}
